import { Button, Box, Typography } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useUser } from "../../context/AuthContext";

const TopMenu = ({
  heading,
  setAddData,
  setData,
  setDrawerFilterOpen,
  filterApplied,
  onClick
}) => {
  const { user } = useUser();
  return (
    <Box
      sx={{
        pt: "2rem",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            textDecoration: "underline",
            paddingLeft: "0",
          }}
        >
          {heading}
        </Typography>
      </Box>
      <Box
        item
        xs={6}
        sx={{
          textAlign: "right",
          my: heading && "1rem",
          mb: "1.5rem",
          width: "100%",
          display: "flex",
          gap: "0.6rem",
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="contained"
          onClick={() =>{onClick && onClick(); setDrawerFilterOpen(true)}}
          sx={{
            backgroundColor: "#ffffff",
            color: "black",
            "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
            "&:hover .dot-icon": {
              color: "#FFFFFF",
            },
          }}
        >
          Filter
          <FilterListIcon />
          {filterApplied && (
            <FiberManualRecordIcon
              className="dot-icon"
              sx={{
                fontSize: "10px",
                color: "#488257",
                marginLeft: "5px",
              }}
            />
          )}
        </Button>
        {!user?.companyAdmin && (
          <Button
            variant="contained"
            endIcon={<AddIcon />}
            sx={{
              backgroundColor: "#1c486b",
              fontSize: "14px",
              textTransform: "none",
            }}
            onClick={() => {
              setAddData(true);
              setData(null);
            }}
          >
            Add New
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default TopMenu;
